import { Box, FormControl, MenuItem, OutlinedInput, Select, type SelectChangeEvent } from '@mui/material'
import React from 'react'

type Props = {
	value: '' | 'true' | 'false'
	placeholder: string
	onChange: (value: '' | 'true' | 'false') => void
}

export const BooleanFilter: React.FC<Props> = ({ value, placeholder, onChange }) => (
	<FormControl fullWidth size="small" variant="standard" onClick={(e) => e.stopPropagation()}>
		<Select
			value={value}
			onChange={(e: SelectChangeEvent<string>) => onChange((e.target.value || '') as '' | 'true' | 'false')}
			onKeyDown={(e) => e.stopPropagation()}
			displayEmpty
			renderValue={(selected) => {
				if (selected === '') {
					return <Box sx={{ color: 'text.disabled', py: '3px' }}>{placeholder}</Box>
				}
				return <Box sx={{ py: '3px' }}>{selected === 'true' ? 'Yes' : 'No'}</Box>
			}}
			input={<OutlinedInput size="small" />}
		>
			<MenuItem value="">
				<em>{placeholder || '—'}</em>
			</MenuItem>
			<MenuItem value="true">Yes</MenuItem>
			<MenuItem value="false">No</MenuItem>
		</Select>
	</FormControl>
)
